import { render, staticRenderFns } from "./PopPyramidChart.vue?vue&type=template&id=539c6fc9&scoped=true&"
import script from "./PopPyramidChart.vue?vue&type=script&lang=js&"
export * from "./PopPyramidChart.vue?vue&type=script&lang=js&"
import style0 from "./PopPyramidChart.vue?vue&type=style&index=0&id=539c6fc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539c6fc9",
  null
  
)

export default component.exports